module.exports = __webpack_public_path__ + "static/media/Star.611e692b.png";